/**
 * navigation_dataPages_Maint_Component_Create_JSX.tsx
 *
 * Create JSX of Navigation_dataPages_Maint_Root_Component Component
 *
 */

import React from 'react'
import {
    Navigation_dataPages_Maint_Root_Component,
    Navigation_dataPages_Maint_Root_Component_Props_PropsValue
} from "page_js/data_pages/data_pages_common/navigation_data_pages_maint/navigation_dataPages_Maint_Component";

/**
 *
 * Create JSX of Navigation_dataPages_Maint_Root_Component Component
 *
 */
export const navigation_dataPages_Maint_Component_Create_JSX = function ({

    navigation_dataPages_Maint_Root_Component_Props_PropsValue
} : {
    navigation_dataPages_Maint_Root_Component_Props_PropsValue : Navigation_dataPages_Maint_Root_Component_Props_PropsValue
}) {

    return (
        <Navigation_dataPages_Maint_Root_Component
            propsValue={ navigation_dataPages_Maint_Root_Component_Props_PropsValue }
        />
    )
}